import React from 'react';
import styles from './ComingSoon.module.scss';

const ComingSoon = ()=>{
  return (<div className={`comingSoon noselect`}>Coming soon!</div>);
}
;

export default ComingSoon;
